import { useContext, useEffect, useState } from "react";
import { postApi, putApi } from "../../services/api/globalApi";
import { Field, Form, Formik } from "formik";
import { motion } from "framer-motion"
import { toast } from "react-toastify";
import { context } from "../../context/context";
import { warningMessage } from "../../utils/toastify-message/ToastifyMessage";
import { FaTimesCircle } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router";
import Select from "../../components/common/inputs/Select";


const UserLoansFormula = () => {

    const location = useLocation()

    const navigate = useNavigate()
    useEffect(() => {
        if (location?.state) {
            setMonths(location.state?.months)
        }
    }, [location?.state])

    const { showLogutModal } = useContext(context)

    const [months, setMonths] = useState([])
    const [monthsNumber, setMonthsNumber] = useState("")


    const addMonthNumber = () => {
        if (monthsNumber) {
            const isExist = months.filter((item) => item.value === Number(monthsNumber))
            if (isExist.length > 0) {
                warningMessage("این عدد از قبل وجود دارد.")
                return null
            }
            months.push({ value: Number(monthsNumber) })
            setMonthsNumber("")
        } else {
            warningMessage("لطفا عدد ماه را وارد کنید")
        }
    }

    const deleteMonth = (value) => {
        const filteredMonth = months.filter((item) => item.value !== value)
        setMonths(filteredMonth);
    }




    const formHandler = async (values, { resetForm }) => {
        const newValues = ({ ...values, ...{amount: Number(values.amount), annualBankInterest: Number(values.annualBankInterest), annualCheque: Number(values.annualCheque), totalAnnual: Number(values.totalAnnual) }, months });
        try {
            const body = JSON.stringify(newValues)
            if (location?.state) {
                const response = await putApi({
                    path: `admin/loanCalculations/${location?.state?._id}`,
                    body: body
                });
                toast.success("نرخ بانک با موفقیت تغییر داده شد.", {
                    position: "top-right",
                    closeOnClick: true
                });
                console.log(response);
            } else {
                const response = await postApi({
                    path: 'admin/loanCalculations',
                    body: body
                });
                toast.success("نرخ بانک با موفقیت ثبت شد.", {
                    position: "top-right",
                    closeOnClick: true
                });
                console.log(response);
            }
            resetForm()
            setMonths([])
            navigate(`/user-formula-list`);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.errors.message, {
                position: "top-right",
                closeOnClick: true
            });
            error?.response.status == 401 && showLogutModal();
        }
    }
    console.log(monthsNumber);
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
                duration: 0.5,
                // ease: [0, 0.71, 0.2, 1.01]
            }} className="w-11/12 mx-auto rounded-lg my-6 bg-white/50 backdrop-blur-sm dark:bg-[#060d26]/50 shadow-lg p-6">

            <h6 className="mb-6 mt-2 text-gray-800 dark:text-white flex gap-x-2 items-center">
                <span className="flex items-center justify-center text-lg text-white">
                    <svg fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        className="h-6 w-6">
                        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"></path>
                    </svg>
                </span>
                {
                    location?.state ? "ویرایش" : "افزودن"
                } نرخ امتیاز کاربران
            </h6>

            <div className="dark:text-white w-11/12 mx-auto mt-4">

                <div className="flex gap-x-8 mt-6">
                    <div className="w-full flex gap-x-6">
                        <Formik
                            initialValues={
                                location?.state ?
                                    {
                                        bankName: location?.state?.bankName,
                                        annualType: location?.state?.annualType,
                                        calcType: location?.state?.calcType,
                                        amount: location?.state?.amount,
                                        annualBankInterest: location?.state?.annualBankInterest,
                                        annualCheque: location?.state?.annualCheque,
                                        totalAnnual: location?.state?.totalAnnual,
                                        status: location?.state?.status,
                                    }
                                    :
                                    {
                                        bankName: '',
                                        amount: 0,
                                        calcType: 'RESALAT',
                                        annualType: 'percent',
                                        annualBankInterest: '',
                                        annualCheque: '',
                                        totalAnnual: '',
                                        status: 'active',
                                    }}
                            enableReinitialize="true"
                            // validationSchema={validate}
                            onSubmit={formHandler}

                        >
                            {(formik) => (
                                <Form className="w-full">
                                    <div className="grid gap-6 mb-6 md:grid-cols-2">
                                        <div>
                                            <label for="bankName" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نام بانک</label>
                                            <Field autocomplete="off" type="text" name="bankName" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="نام بانک" />
                                            {formik.errors.bankName && formik.touched.bankName ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.bankName}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="annualType" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نوع نرخ سالانه</label>
                                            <Field as="select" name="annualType"
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            >
                                                <option value={"percent"}>درصد</option>
                                                <option value={"price"}>قیمت</option>
                                            </Field>
                                            {formik.errors.annualType && formik.touched.annualType ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.annualType}</p>
                                            ) : null}
                                        </div>

                                        <div>
                                            <label for="annualBankInterest" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نرخ سالانه</label>
                                            <Field autocomplete="off" type="text" name="annualBankInterest" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="نرخ سالانه" />
                                            {formik.errors.annualBankInterest && formik.touched.annualBankInterest ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.annualBankInterest}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="annualCheque" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نرخ سالانه چکی</label>
                                            <Field autocomplete="off" type="text" name="annualCheque" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="نرخ سالانه چکی" />
                                            {formik.errors.annualCheque && formik.touched.annualCheque ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.annualCheque}</p>
                                            ) : null}
                                        </div>

                                        <div>
                                            <label for="totalAnnual" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نرخ کل</label>
                                            <Field autocomplete="off" type="text" name="totalAnnual" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="نرخ کل" />
                                            {formik.errors.totalAnnual && formik.touched.totalAnnual ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.totalAnnual}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="amount" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">مبلغ وام</label>
                                            <Field autocomplete="off" type="text" name="amount" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="مبلغ وام" />
                                            {formik.errors.amount && formik.touched.amount ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.amount}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="calcType" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">نوع محاسبه بانکی</label>
                                            <Field as="select" name="calcType"
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            >
                                                <option value={"RESALAT"}>رسالت</option>
                                                <option value={"SEPAH"}>سپه</option>
                                                <option value={"MEHR"}>مهر</option>
                                                <option value={"MASKAN"}>مسکن</option>
                                            </Field>
                                            {formik.errors.calcType && formik.touched.calcType ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.calcType}</p>
                                            ) : null}

                                        </div>
                                        <div>
                                            <label for="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">وضعیت</label>
                                            <Field as="select" name="status"
                                                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            >
                                                <option value={'active'}>فعال</option>
                                                <option value={'inactive'}>غیر فعال</option>
                                            </Field>
                                            {formik.errors.status && formik.touched.status ? (
                                                <p className="text-sm my-4 text-red-500">{formik.errors.status}</p>
                                            ) : null}
                                        </div>
                                        <div>
                                            <label for="rate" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">ماه</label>
                                            <input value={monthsNumber} onChange={(e) => setMonthsNumber(e.target.value)} autocomplete="off" type="text" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                placeholder="ماه" />
                                        </div>
                                        <div className="flex items-end">
                                            <button onClick={addMonthNumber} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                                افزودن ماه
                                            </button>
                                        </div>
                                    </div>


                                    <div className="flex flex-wrap gap-6 mb-6">
                                        {months?.length > 0 ?
                                            months.map((item, index) => {
                                                return (
                                                    <span key={index} className="inline-flex gap-3 items-center rounded-md bg-green-400/10 px-2 py-1 text-base font-medium text-green-400 inset-ring inset-ring-green-500/20">
                                                        {item.value}

                                                        <FaTimesCircle className="text-red-500 cursor-pointer" onClick={() => { deleteMonth(item.value) }} size={24} />

                                                    </span>
                                                )
                                            })
                                            : null
                                        }
                                    </div>

                                    <div className="grid gap-6 mb-6 md:grid-cols-2">

                                    </div>
                                    <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-10 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                        {location?.state ? "ویرایش" : "ثبت"}
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </motion.div>
    )
}

export default UserLoansFormula